export const SchemesData = {
  'united-kingdom': [
    {
      question: 'What Are the Requirements for Registration?',
      answer: 'Freight forwarders in the UK must register with HMRC to handle customs clearances legally. This registration is required to operate within the UK logistics framework and to perform customs formalities.',
    },
    {
      question: 'Are There Specific Licensing Requirements?',
      answer: 'Goods vehicle operators (carriers) must obtain a Goods Vehicle Operator Licence to operate. The licence ensures operators meet safety, environmental and operational standards required for legal and efficient freight movement.',
    },
    {
      question: 'What Are the Compliance Standards?',
      answer: 'Freight forwarders must comply with UK trade and safety regulations, which include maintaining accurate documentation, following relevant industry rules such as IATA for air freight, and holding appropriate insurance to cover liabilities.',
    },
  ],
}

export const generateSchemeObject = (path: string) => {
  if (!path) return;

  const countryFaq = SchemesData[path as keyof typeof SchemesData];

  if (!countryFaq) return;

  const questionAnswerObjects = countryFaq.map((item) => {
    return {
      '@type': 'Question',
      'name': item.question,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': item.answer,
      },
    }
  });

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': questionAnswerObjects,
  };
};